<script lang="ts">
  import * as Table from "$lib/components/ui/table";
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import {
    projectDraft,
    projectOriginal,
  } from "$src/application/projects/stores/projectStore";
  import { formatCurrency } from "$src/presentation/core/currencyUtils";
  import { t } from "svelte-i18n";
  import PriceMarginAmount from "./price-margin-amount.svelte";
  import PriceMarginPercent from "./price-margin-percent.svelte";
  import VatInfo from "../infos/vat-info.svelte";

  export let marginVisible: boolean = false;

  $: projectPrices =
    isEditActive && $projectDraft
      ? $projectDraft.prices
      : $projectOriginal.prices;
  $: store =
    isEditActive && $projectDraft
      ? $projectDraft.info.store
      : $projectOriginal.info.store;
</script>

<Table.Root
  class="text-right max-w-xs min-w-xs caption-top {$isEditActive
    ? 'self-start'
    : ''} "
>
  <Table.Caption class="text-md text-left ">
    <div class="flex flex-row justify-between ">
      {$t("page.projects.detail.amounts.totals")}
      {#if store}
        <VatInfo countryCode={store.countryCode} />
      {/if}
    </div>
  </Table.Caption>
  <Table.Body>
    {#each projectPrices.amounts as amount}
      <Table.Row class="border-b-0">
        <Table.Cell class="text-xs">
          {$t("page.projects.detail.amounts.amountExVat", {
            values: { vatPercent: amount.vatPercent },
          })}
        </Table.Cell>
        <Table.Cell class="font-medium text-right pr-4">
          {formatCurrency(amount.amountExVat, projectPrices.currency)}
        </Table.Cell>
      </Table.Row>
      <Table.Row class="border-b-0">
        <Table.Cell class="text-xs">
          {$t("page.projects.detail.amounts.vatAmount", {
            values: { vatPercent: amount.vatPercent },
          })}
        </Table.Cell>
        <Table.Cell class="font-medium text-right pr-4">
          {formatCurrency(amount.vatAmount, projectPrices.currency)}
        </Table.Cell>
      </Table.Row>
    {/each}
    <Table.Row class="border-b-0">
      <Table.Cell class="text-xs">
        {$t("page.projects.detail.amounts.amountNoDiscount")}
      </Table.Cell>
      <Table.Cell class="font-medium text-right pr-4">
        {formatCurrency(
          projectPrices.totalAmountIncVatNoDiscount,
          projectPrices.currency
        )}
      </Table.Cell>
    </Table.Row>
    <Table.Row class="border-b-0">
      <Table.Cell class="text-xs">
        {$t("page.projects.detail.amounts.discount")}
      </Table.Cell>
      <Table.Cell class="font-medium text-right pr-4">
        {formatCurrency(
          projectPrices.totalDiscountIncVat,
          projectPrices.currency
        )}
      </Table.Cell>
    </Table.Row>
    <Table.Row class="border-b-0">
      <Table.Cell class="font-medium  text-lg md:text-xl">
        {$t("page.projects.detail.amounts.totalVatIncl")}
      </Table.Cell>
      <Table.Cell
        class="font-medium text-lg md:text-2xl text-right rounded-xl bg-primary/50 text-primary-foreground"
      >
        {formatCurrency(
          projectPrices.totalAmountIncVat,
          projectPrices.currency
        )}
      </Table.Cell>
    </Table.Row>
    {#if marginVisible}
      <Table.Row class="border-b-0">
        <Table.Cell>{$t("page.projects.detail.amounts.margin")}</Table.Cell>
        <Table.Cell class="gap-2 flex flex-col w-full">
          <PriceMarginAmount
            value={projectPrices.totalMarginExVat}
            currency={projectPrices.currency}
          />
          <PriceMarginPercent value={projectPrices.totalMarginPercent} />
        </Table.Cell>
      </Table.Row>
    {/if}
    <!-- <Table.Row class="border-b-0">
      <Table.Cell colspan={2} class="p-0">
        {#if store}
          <VatInfo countryCode={store.countryCode} />
        {/if}
      </Table.Cell>
    </Table.Row> -->
  </Table.Body>
</Table.Root>
